export default __webpack_public_path__ + "static/media/gb.cc2cb413.svg";